export default "__VITE_ASSET__CEspFagO__";